import {createSlice} from "@reduxjs/toolkit";

let windowWidth = window.innerWidth;

const bodySlice = createSlice({
    name: "mainBody",
    initialState: {
        status: 1,
        isClass: '',
        menu:[]
    },

    reducers: {
        toggleClass: (state, action) => {
            return false;
            let mainClass = 'sidebar-collapse';
            let status = 0;

            if (state.status == 0) {
                status = 1;
                mainClass = '';
                if (windowWidth < 768) {
                    mainClass = 'sidebar-open';
                }
            }

            state.status = status;
            state.isClass = mainClass;

        },
        setMenu: (state, action) => {
            state.menu = action.payload;
        }
    }
});

const {reducer, actions} = bodySlice;
export const {toggleClass, setMenu} = actions;
export default reducer;
